import React from "react";
// Common Components
import { Button, AddButton, Modal } from "src/Components";
// Local Components
import AddOrEditModal from "./AddOrEditModal";
import BubbleConfigModal from "./BubbleConfigModal";
import DeltaConfigModal from "./DeltaConfigModal";
import RemainingDayConfigModal from "./RemainingDayConfigModal";
import SellOrBuyQueueConfigModal from "./SellOrBuyQueueConfigModal";
import BaseHedgerPairTable from "./BaseHedgerPairTable";

type IModal =
  | "isBubbleConfigModalOpen"
  | "isDeltaConfigModalOpen"
  | "isRemainingDayConfigModalOpen"
  | "isAddOrEditModalOpen"
  | "isSellQueueConfigModalOpen"
  | "isBuyQueueConfigModalOpen";

const defaultModalState = {
  isBubbleConfigModalOpen: false,
  isDeltaConfigModalOpen: false,
  isRemainingDayConfigModalOpen: false,
  isSellQueueConfigModalOpen: false,
  isBuyQueueConfigModalOpen: false,
  isAddOrEditModalOpen: false,
};

const BaseHedgerPair: React.FC = () => {
  // Local Store
  const [modal, setModal] = React.useState(defaultModalState);
  const [refreshFlag, setRefreshFlag] = React.useState(false);

  const handelModalOpen = (type: IModal) => () =>
    setModal({ ...defaultModalState, [type]: true });
  const handleModalClose = (type: IModal) => () =>
    setModal({ ...defaultModalState, [type]: false });

  const getModalUI = () => {
    if (modal.isBubbleConfigModalOpen) {
      return (
        <Modal
          title="متغیرهای ضریب حباب"
          onClose={handleModalClose("isBubbleConfigModalOpen")}
          UI={
            <BubbleConfigModal
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isBubbleConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }

    if (modal.isDeltaConfigModalOpen) {
      return (
        <Modal
          title="متغیرهای ضریب دلتا"
          onClose={handleModalClose("isDeltaConfigModalOpen")}
          UI={
            <DeltaConfigModal
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isDeltaConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }

    if (modal.isRemainingDayConfigModalOpen) {
      return (
        <Modal
          title="متغیرهای ضریب روز تا سررسید"
          onClose={handleModalClose("isRemainingDayConfigModalOpen")}
          UI={
            <RemainingDayConfigModal
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isRemainingDayConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }

    if (modal.isSellQueueConfigModalOpen) {
      return (
        <Modal
          title="متغیرهای ضریب صف فروش"
          onClose={handleModalClose("isSellQueueConfigModalOpen")}
          UI={
            <SellOrBuyQueueConfigModal
              type="sell"
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isSellQueueConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }

    if (modal.isBuyQueueConfigModalOpen) {
      return (
        <Modal
          title="متغیرهای ضریب صف خرید"
          onClose={handleModalClose("isBuyQueueConfigModalOpen")}
          UI={
            <SellOrBuyQueueConfigModal
              type="buy"
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isBuyQueueConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }
    if (modal.isAddOrEditModalOpen) {
      return (
        <Modal
          title="افزودن جفت هج"
          onClose={handleModalClose("isBuyQueueConfigModalOpen")}
          UI={
            <AddOrEditModal
              onSuccess={() => setRefreshFlag(true)}
              onClose={handleModalClose("isBuyQueueConfigModalOpen")}
            />
          }
          modalBoxClassName="!min-w-[300px]"
        />
      );
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full">
      {getModalUI()}
      <AddButton onClick={handelModalOpen("isAddOrEditModalOpen")} />
      <div className="flex flex-row justify-start items-center gap-4 ">
        <Button
          text="متغیرهای ضریب حباب"
          variant="outlined"
          onClick={handelModalOpen("isBubbleConfigModalOpen")}
        />
        <Button
          text="متغیرهای ضریب دلتا"
          variant="outlined"
          onClick={handelModalOpen("isDeltaConfigModalOpen")}
        />
        <Button
          text="متغیرهای ضریب روز تا سررسید"
          variant="outlined"
          onClick={handelModalOpen("isRemainingDayConfigModalOpen")}
        />
        <Button
          text="متغیرهای ضریب صف خرید"
          variant="outlined"
          onClick={handelModalOpen("isBuyQueueConfigModalOpen")}
        />
        <Button
          text="متغیرهای ضریب صف فروش"
          variant="outlined"
          onClick={handelModalOpen("isSellQueueConfigModalOpen")}
        />
      </div>
      <BaseHedgerPairTable
        refreshFlag={refreshFlag}
        onFetchComplete={() => setRefreshFlag(false)}
      />
    </div>
  );
};

export default BaseHedgerPair;
